import PaymentMethod from "../../components/payment-method";
import TotalCount from "../../components/total-count";
import cx from "classnames";
import css from "./style.scss";
import useInvoice from "../../hooks/useInvoice";
import SelectNetwork from "../../components/select-network";
import SendPayment from "../../components/send-payment";
import DontClose from "../../components/dont-close";
import Loader from "../../components/loader";

const Payment = (props) => {
  const { invoice, initInvoice } = useInvoice();
  const { invoiceId, currency, network } = props;

  initInvoice(invoiceId, currency, network, 'NEW');

  return (
    <main className={cx(invoice.loading && "loading")}>
      {
        invoice.loading ? (
          <div className={cx(css.wrapper)}>
            <Loader />
          </div>
        ) : (
          <>
            {
              !currency && !network ? (
                <div className={cx(css.wrapper)}>
                  <TotalCount/>
                  <PaymentMethod/>
                </div>
              ) : null
            }

            {
              currency && !network && invoice.currency?.types?.length > 1 ? (
                <div className={cx(css.wrapper)}>
                  <TotalCount/>
                  <SelectNetwork/>
                </div>
              ) : null
            }

            {
              (currency && network) || (currency && invoice.currency?.types?.length === 1) ? (
                <div className={cx(css.wrapper)}>
                  <SendPayment/>
                  <DontClose/>
                </div>
              ) : null
            }
          </>
        )
      }
    </main>
  );
};

export default Payment;
